export default __webpack_public_path__ + "static/media/page-title-contact.bfaef088.svg";